import React from "react";
import type { ChartBlock } from "@/types/contentBlocks";
import { ChartRenderer } from "@/components/ChartRenderer";

interface ChartBlockRendererProps {
  block: ChartBlock;
  isDarkMode?: boolean;
}

export const ChartBlockRenderer: React.FC<ChartBlockRendererProps> = ({
  block,
  isDarkMode = false,
}) => {
  if (!block.config || !Array.isArray(block.config.data)) {
    return null;
  }

  return (
    <div className="my-4">
      <ChartRenderer config={block.config} isDarkMode={isDarkMode} />
    </div>
  );
};
